import { render, staticRenderFns } from "./myApplication.vue?vue&type=template&id=2087d66c&scoped=true"
import script from "./myApplication.vue?vue&type=script&lang=js"
export * from "./myApplication.vue?vue&type=script&lang=js"
import style0 from "./myApplication.vue?vue&type=style&index=0&id=2087d66c&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2087d66c",
  null
  
)

export default component.exports